import script from "./SliderControl.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderControl.vue?vue&type=script&setup=true&lang=js"

import "./SliderControl.vue?vue&type=style&index=0&id=41ae3b9b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41ae3b9b"]])

export default __exports__